<template>
  <div>
    <div>
      <!-- <Tag
        v-for="item in count"
        :key="item"
        :name="item"
        closable
        @on-close="handleClose2"
      >标签{{ item + 1 }}</Tag>
      <Input search enter-button placeholder="Enter something..."/>
      <Button icon="ios-add" type="dashed" size="small" @click="handleAdd">添加条件</Button>-->
      <Button type="primary" icon="ios-search" @click="searchByConditionsView2">按条件查询</Button>
    </div>

    <!-- 模态框 -->
    <div>
      <Modal title="Title" v-model="modal10" :mask-closable="false" width="380">
        <p slot="header" style="color:#0066FF;text-align:center">
          <Icon type="md-create" />
          <span>按条件检索</span>
        </p>
        <div style="text-align:center">
          <CheckboxGroup v-model="selectedCondition" class="check_grop">
            <div>
              <Row type="flex" justify="center" align="middle">
                <Col span="9" style="text-align: right;margin=left:5px">
                  <Checkbox label="deviceId">
                    <span>设备编号</span>
                  </Checkbox>
                </Col>
                <Col span="15" style="text-align: left">
                  <Input v-model="deviceIdModel" placeholder="请输入设备编号" style="width: 150px" />
                </Col>
              </Row>
            </div>
            <div>
              <Row type="flex" justify="center" align="middle">
                <Col span="9" style="text-align: right;margin=left:5px">
                  <Checkbox label="idcard">
                    <span>证件编号</span>
                  </Checkbox>
                </Col>
                <Col span="15" style="text-align: left">
                  <Input v-model="idcardModel" placeholder="请输入证件编号" style="width: 150px" />
                </Col>
              </Row>
            </div>
            <div>
              <Row type="flex" justify="center" align="middle">
                <Col span="9" style="text-align: right;margin=left:5px">
                  <Checkbox label="name">
                    <span>户主姓名</span>
                  </Checkbox>
                </Col>
                <Col span="15" style="text-align: left">
                  <Input v-model="nameModel" placeholder="请输入户主姓名" style="width: 150px" />
                </Col>
              </Row>
            </div>
            <div>
              <Row type="flex" justify="center" align="middle">
                <Col span="9" style="text-align: right;margin=left:5px">
                  <Checkbox label="openAddress">
                    <span>开户地址</span>
                  </Checkbox>
                </Col>
                <Col span="15" style="text-align: left">
                  <Cascader
                    v-model="openAddressModel"
                    placeholder="请选择开户地址"
                    :data="addressData"
                    filterable
                    change-on-select
                    trigger="click"
                    style="width: 150px"
                  ></Cascader>
                </Col>
              </Row>
            </div>
          </CheckboxGroup>
        </div>
        <div slot="footer">
          <Button icon="md-search" type="info" size="large" long @click="searchByCondition">检索</Button>
        </div>
      </Modal>

      <Modal title="Title" v-model="modal8" :mask-closable="false" width="380">
        <p slot="header" style="color:#0066FF;text-align:center">
          <Icon type="md-create" />
          <span>按条件检索</span>
        </p>
        <div style="text-align:center">
          <CheckboxGroup v-model="selectedCondition2" class="check_grop">
            <!-- <div>
              <Checkbox label="saveId">
                <span>存储编号</span>
              </Checkbox>
              <Input v-model="saveIdModel" placeholder="请输入存储编号" style="width: 150px" />
            </div>
            <div>
              <Checkbox label="deviceId">
                <span>设备编号</span>
              </Checkbox>
              <Input v-model="deviceIdModel" placeholder="请输入设备编号" style="width: 150px" />
            </div>-->
            <!-- <div>
              <Checkbox label="commandId">
                <span>命令字&nbsp;&nbsp;&nbsp;</span>
              </Checkbox>
              <Select v-model="commandIdModel" style="width:150px" placeholder="请选择命令字">
                <Option v-for="(value, key) in commandEnum" :value="key" :key="value">{{value}}</Option>
              </Select>
            </div>-->
            <div>
              <Checkbox label="timeStamp">
                <span>时间区间</span>
              </Checkbox>
              <Tooltip
                transfer
                placement="top"
                :disabled="timeStampModel == undefined || timeStampModel[0] == ''"
              >
                <div slot="content">
                  <span>{{dateFtt('yyyy-MM-dd hh:mm:ss',timeStampModel[0])}}</span>
                  <br />
                  <span style="margin-left:50%">~</span>
                  <br />
                  <span>{{dateFtt('yyyy-MM-dd hh:mm:ss',timeStampModel[1])}}</span>
                </div>
                <DatePicker
                  v-model="timeStampModel"
                  type="daterange"
                  split-panels
                  placeholder="请选择时间区间"
                  style="width: 150px"
                ></DatePicker>
              </Tooltip>
            </div>
          </CheckboxGroup>
        </div>
        <div slot="footer">
          <Button icon="md-search" type="info" size="large" long @click="searchByCondition2">检索</Button>
        </div>
      </Modal>

      <Modal title="Title" v-model="modal9" :mask-closable="false" width="980">
        <p slot="header" style="color:#0066FF;text-align:center">
          <Icon type="md-create" />
          <span>{{"设备编号: " + selectMeterId}}</span>
        </p>
        <div style="text-align:left">
          <Button
            style="margin-top:-15px;margin-bottom:5px"
            type="primary"
            icon="ios-search"
            @click="searchByConditionsView"
          >按条件查询</Button>
          <Table
            width="945"
            size="large"
            border
            stripe
            :loading="loading"
            :columns="columns2"
            :data="data2"
          ></Table>
          <br />
          <div>
            <Page
              :current="pageNo2"
              :total="pageTotal2"
              :page-size="pageSize2"
              :page-size-opts="[5, 10, 20, 30, 40]"
              show-sizer
              show-total
              @on-change="changePage2"
              @on-page-size-change="changePageSize2"
            />
          </div>
        </div>
        <div slot="footer"></div>
      </Modal>
    </div>
    <br />
    <Table
      :width="width * 0.8"
      size="large"
      border
      stripe
      :loading="loading"
      :columns="columns1"
      :data="data1"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button type="primary" shape="circle" icon="ios-apps" @click="showData(row, index)"></Button>
      </template>
    </Table>
    <br />
    <Page
      :current="pageNo"
      :total="pageTotal"
      :page-size="pageSize"
      :page-size-opts="[5, 10, 20, 30, 40]"
      show-sizer
      show-total
      @on-change="changePage"
      @on-page-size-change="changePageSize"
    />
  </div>
</template>

<script>
import { constants } from "crypto";
export default {
  name: "metering_data",
  mounted() {
    // this.tableHeight =
    //   window.innerHeight - this.$refs.table.$el.offsetTop - 160;
    this.getAddresTree();
  },
  created() {
    this.request();
  },
  methods: {
    dateFtt(fmt, date) {
      return global.dateFtt(fmt, new Date(date));
    },
    request() {
      var that = this;
      this.pageNo = 1;
      $.ajax({
        url: "/api/getMeterInfoByConditions",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          page: that.pageNo,
          amount: that.pageSize,
          direction: "down",
          conditions: that.requestBody
        }),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          that.$Notice.success({
            title: "提示",
            desc: "载入设备数据成功"
          });
          that.data1 = data.body.resultList;
          that.pageTotal = data.body.amount;
          that.loading = false;
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },

    ok() {},
    cancel() {},
    del() {},
    // 修改页面容量
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.request();
    },
    changePageSize2(pageSize) {
      this.pageSize2 = pageSize;
      var that = this;
      that.loading = true;
      this.modal9 = false;
      this.pageNo2 = 1;
      $.ajax({
        url: "/api/selectInstructions",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          page: that.pageNo2,
          amount: that.pageSize2,
          direction: "up",
          conditions: {
            commandId: "0x85",
            deviceId: that.selectMeterId
          }
        }),
        dataType: "json",
        success: function(data) {
          if (data.errorCode == 0) {
            that.data2 = data.body.resultList;
            that.pageTotal2 = data.body.amount;
            that.modal9 = true;
            console.log(data);
          } else {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
          }
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.loading = false;
        }
      });
    },
    // 修改
    changePage2(index) {
      this.pageNo2 = index;
      var that = this;
      that.loading = true;
      $.ajax({
        url: "/api/selectInstructions",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          page: that.pageNo2,
          amount: that.pageSize2,
          conditions: {
            commandId: "0x85",
            deviceId: that.selectMeterId
          }
        }),
        dataType: "json",
        success: function(data) {
          console.log(data);
          if (data.errorCode == 0) {
            that.data2 = data.body.resultList;
            that.pageTotal2 = data.body.amount;
            that.loading = false;
          } else {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
          }
          that.loading = false;
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    changePage(index) {
      this.pageNo = index;
      var that = this;
      that.loading = true;
      $.ajax({
        url: "/api/getMeterInfoByConditions",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          page: that.pageNo,
          amount: that.pageSize,
          direction: "down",
          conditions: that.requestBody
        }),
        dataType: "json",
        success: function(data) {
          console.log(data);
          if (data.errorCode == 0) {
            that.data1 = data.body.resultList;
            that.pageTotal = data.body.amount;
            that.loading = false;
          } else {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
          }
          that.loading = false;
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    // 按条件检索点击事件
    // 按条件检索点击事件
    searchByCondition() {
      this.requestBody = {};

      for (var temp in this.selectedCondition) {
        if (this.selectedCondition[temp] == "deviceId") {
          if (this.deviceIdModel == "") {
            continue;
          }

          this.requestBody["deviceId"] = this.deviceIdModel;
          // requestBody.set("deviceId", this.deviceIdModel);
        }
        if (this.selectedCondition[temp] == "idcard") {
          if (this.idcardModel == "") {
            continue;
          }

          this.requestBody["idcardModel"] = this.idcardModel;
          // requestBody.set("saveId", this.saveIdModel);
        }
        if (this.selectedCondition[temp] == "name") {
          if (this.nameModel == "") {
            continue;
          }
          this.requestBody["nameModel"] = this.nameModel;
        }
        if (this.selectedCondition[temp] == "openAddress") {
          if (this.openAddressModel == "") {
            continue;
          }
          this.requestBody["openAddress"] = this.openAddressModel[
            this.openAddressModel.length - 1
          ];
        }
      }

      // 调用接口查询
      var that = this;
      that.loading = true;
      this.modal8 = false;
      this.pageNo = 1;
      // if(that.requestBody.openAddress){
      //     that.requestBody.openAddress = that.requestBody.openAddress * 1;
      // }
      $.ajax({
        url: "/api/getMeterInfoByConditions",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          page: that.pageNo,
          amount: that.pageSize,
          direction: "down",
          conditions: that.requestBody
        }),
        dataType: "json",
        success: function(data) {
          console.log(data);
          if (data.errorCode == 0) {
            that.$Notice.success({
              title: "提示",
              desc: "载入设备数据成功"
            });
            that.data1 = data.body.resultList;
            that.pageTotal = data.body.amount;
            that.loading = false;
          } else {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
          }
          that.loading = false;
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    searchByCondition2() {
      let requestBodytemp = {
        commandId: "0x85",
        deviceId: this.selectMeterId
      };
      console.log(this.selectedCondition2);
      for (var temp in this.selectedCondition2) {
        if (this.selectedCondition2[temp] == "commandId") {
          if (this.commandIdModel == "") {
            continue;
          }

          requestBodytemp["commandId"] = this.commandIdModel;
          // requestBody.set("commandId", this.commandIdModel);
        }
        if (this.selectedCondition2[temp] == "deviceId") {
          if (this.deviceIdModel == "") {
            continue;
          }

          requestBodytemp["deviceId"] = this.deviceIdModel;
          // requestBody.set("deviceId", this.deviceIdModel);
        }
        if (this.selectedCondition2[temp] == "saveId") {
          if (this.saveIdModel == "") {
            continue;
          }

          requestBodytemp["saveId"] = this.saveIdModel;
          // requestBody.set("saveId", this.saveIdModel);
        }
        if (this.selectedCondition2[temp] == "timeStamp") {
          if (this.timeStampModel[0] == "" || this.timeStampModel[1] == "") {
            continue;
          }

          let startYear = this.timeStampModel[0].getFullYear().toString();
          let startMonth =
            this.timeStampModel[0].getMonth() >= 9
              ? (this.timeStampModel[0].getMonth() + 1).toString()
              : "0" + (this.timeStampModel[0].getMonth() + 1);
          let startDate =
            this.timeStampModel[0].getDate() >= 9
              ? this.timeStampModel[0].getDate().toString()
              : "0" + this.timeStampModel[0].getDate();

          let endYear = this.timeStampModel[1].getFullYear().toString();
          let endMonth =
            this.timeStampModel[1].getMonth() >= 9
              ? (this.timeStampModel[1].getMonth() + 1).toString()
              : "0" + (this.timeStampModel[1].getMonth() + 1);
          let endDate =
            this.timeStampModel[1].getDate() >= 9
              ? this.timeStampModel[1].getDate().toString()
              : "0" + this.timeStampModel[1].getDate();

          requestBodytemp["timeStamp"] =
            startYear +
            "/" +
            startMonth +
            "/" +
            startDate +
            "-" +
            endYear +
            "/" +
            endMonth +
            "/" +
            endDate;
          // requestBody.set(
          //   "timeStamp",
          //   startYear +
          //     "/" +
          //     startMonth +
          //     "/" +
          //     startDate +
          //     "-" +
          //     endYear +
          //     "/" +
          //     endMonth +
          //     "/" +
          //     endDate
          // );
        }
      }

      // 调用接口查询
      var that = this;
      that.loading = true;
      this.modal8 = false;
      this.pageNo = 1;
      $.ajax({
        url: "/api/selectInstructions",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          page: that.pageNo,
          amount: that.pageSize,
          direction: "up",
          conditions: requestBodytemp
        }),
        dataType: "json",
        success: function(data) {
          console.log(data);
          if (data.errorCode == 0) {
            that.$Notice.success({
              title: "提示",
              desc: "查询上传指令数据成功"
            });
            that.data2 = data.body.resultList;
            that.pageTotal2 = data.body.amount;
            that.loading = false;
          } else {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
          }
          that.loading = false;
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    // 显示条件检索页面
    searchByConditionsView() {
      this.modal8 = true;
    },
    searchByConditionsView2() {
      this.modal10 = true;
    },
    handleClose2(event, name) {
      const index = this.count.indexOf(name);
      this.count.splice(index, 1);
    },
    getAddresTree() {
      var that = this;
      $.ajax({
        url: "/api/getAddressTree",
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.addressData = data.body[0].children;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "地址获取异常"
          });
        }
      });
    },
    // 点击事件：点击显示数据集
    showData(row, index) {
      // 当设备编号不为空则调接口查询获取上传信息
      if (row.meterId != undefined && row.meterId != "") {
        this.selectMeterId = row.meterId;
        var that = this;
        that.loading = true;
        this.modal9 = false;
        this.pageNo2 = 1;
        $.ajax({
          url: "/api/selectInstructions",
          contentType: "application/json",
          type: "post",
          data: JSON.stringify({
            page: that.pageNo2,
            amount: that.pageSize2,
            direction: "up",
            conditions: {
              commandId: "0x85",
              deviceId: row.meterId
            }
          }),
          dataType: "json",
          success: function(data) {
            if (data.errorCode == 0) {
              that.data2 = data.body.resultList;
              that.pageTotal2 = data.body.amount;
              that.modal9 = true;
              console.log(data);
            } else {
              that.$Notice.error({
                title: "异常",
                desc: data.errorInfo
              });
            }
          },
          error: function(textStatus) {
            that.loading = false;
            that.$Notice.error({
              title: "异常",
              desc: "接口请求异常"
            });
          },
          complete: function() {
            that.loading = false;
          }
        });
      }
    }
  },
  data() {
    return {
      columns2: [
        // {
        //   title: "存储编号",
        //   key: "saveId",
        //   align: "center",
        //   sortable: true,
        //   width: 120
		// },
        {
          title: "日期",
          sortable: true,
          align: "center",
          render: function(h, params) {
            let data = params.row.time;
            return h("div", data.split(" ")[0]);
          }
        },
        {
          title: "工况流量",
          align: "center",
          width: 120,
          render: function(h, params) {
            let data = params.row.data.当日工况流量;
            return h("div", data);
          }
          // width: 100
        },
        {
          title: "剩余工况流量",
          align: "center",
          width: 140,
          render: function(h, params) {
            let data = params.row.data.剩余工况流量;
            return h("div", data);
          }
        },
        {
          title: "标况流量",
          align: "center",
          width: 120,
          render: function(h, params) {
            let data = params.row.data.当日标况流量;
            return h("div", data);
          }
		},
		{
          title: "剩余标况流量",
          align: "center",
          width: 140,
          render: function(h, params) {
            let data = params.row.data.剩余标况流量;
            return h("div", data);
          }
        },
        {
          title: "剩余金额",
          align: "center",
          width: 120,
          render: function(h, params) {
            let data = params.row.data.剩余金额;
            return h("div", data);
          }
        },
        {
          title: "当前气价",
          align: "center",
          width: 120,
          render: function(h, params) {
            let data = params.row.data.当前气价;
            return h("div", data);
		  }
		}
      ],
      columns1: [
        {
          title: "设备编号",
          key: "meterId",
          width: 180
        },
        {
          title: "计量数据",
          slot: "action",
          width: 100,
          align: "center"
        },
        {
          title: "设备信息",
          children: [
            {
              title: "设备厂商",
              key: "meterManufacturer",
              width: 100
            },
            {
              title: "设备规格",
              key: "meterSpecifications",
              width: 100
            },
            {
              title: "设备入库时间",
              key: "meterCreatedDate",
              width: 200
            }
          ]
        },
        {
          title: "用气类型",
          key: "meterGasTypeName",
          width: 100
        },
        {
          title: "通讯方式",
          key: "meterCommunicationMode",
          width: 100
        },
        {
          title: "设备状态",
          render: function(h, params) {
            let row = params;
            return h(
              "div",
              row.meterUsageState == 0
                ? "待开户"
                : row.meterUsageState == 10
                ? "待安检"
                : row.meterUsageState == 20
                ? "正常使用"
                : row.meterUsageState == -100
                ? "废弃"
                : "异常"
            );
          },
          width: 100
        },
        {
          title: "地址",
          key: "completeAddress",
          width: 300
        }
      ],

      data1: [],
      data2: [],
      addressData: [],
      loading: true,
      showDrawer: false,
      selectDataHtml: "",
      selectData: {},
      modal8: false,
      modal9: false,
      modal10: false,
      pageTotal: 0,
      pageSize: 30,
      pageTotal2: 0,
      pageSize2: 30,
      selectedCondition: [],
      selectedCondition2: [],
      commandEnum: global.upcommand,
      saveIdModel: "",
      deviceIdModel: "",
      openAddressModel: "",
      nameModel: "",
      idcardModel: "",
      commandIdModel: "0x85",
      timeStampModel: "",
      pageNo: 1,
      pageNo2: 1,
      requestBody: {},
      selectMeterId: "",
      width: document.body.clientWidth
    };
  }
};
</script>

<style>
.ivu-notice-notice {
  width: 500px;
  right: 160px;
}
.query_condition {
  border: 1px solid #c0c0c0;
  padding: 2px;
  margin: 2px;
  border-radius: 5%;
}
.check_grop div {
  margin-bottom: 1px;
}
</style>